import { randWord } from '@ngneat/falso';
import { ITeam } from '@principle-theorem/principle-core/interfaces';
import { BaseFirestoreMock, Properties } from '@principle-theorem/shared';

export class TeamMock
  extends BaseFirestoreMock<Properties<ITeam>>
  implements Properties<ITeam>
{
  get name(): string {
    return randWord();
  }
}
